import { createApi } from "../api/client";
import { config } from "../config";
import { createBrowserPlatform } from "../lib/platform";
import { getInitData, roomSocketUrl } from "../lib/telegram";
import { RoomSocket } from "../realtime/RoomSocket";
import { GameController } from "./controller";

/** Собирает контроллер из настоящих зависимостей (браузер + Telegram). */
export function createGameController(): GameController {
  const initData = () => getInitData() ?? "";
  return new GameController({
    api: createApi({ getInitData: initData }),
    createSocket: (roomId) =>
      new RoomSocket({ url: roomSocketUrl(roomId, window.location), getInitData: initData }),
    platform: createBrowserPlatform(),
    getInitData,
    botLink: config.botLink,
    channelUrl: config.channelUrl,
  });
}
